import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Actions = styled.div`
  display: flex;
  gap: 3px;
  position: relative;
`;

export const PrimaryButton = styled(Button)`
  min-width: 0;
  padding: 0 5px;

  &:hover {
    background-color: #c1d9ff;
  }
`;

export const PrimaryButtonText = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const MenuButton = styled(Button)<{ $isMenuOpen: boolean }>`
  flex-shrink: 0;
  padding: 0;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.border};
  }

  ${({ $isMenuOpen }) =>
    $isMenuOpen &&
    css`
      background-color: ${({ theme }) => theme.palette.secondary.border};
    `}
`;

export const Menu = styled.div`
  width: 200px;
  padding: 10px;
`;

export const MenuItem = styled.button`
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 15px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  user-select: none;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const MenuItemText = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))<{ $color?: string }>`
  color: ${({ theme, $color }) => $color ?? theme.palette.primary.labels};
`;

export const SheetContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SheetItem = styled.button<{ $color?: string }>`
  height: 60px;
  display: flex;
  align-items: center;
  border: 0;
  background: transparent;
  text-align: left;
  user-select: none;

  border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.border};

  &:last-child {
    margin-bottom: 30px;
  }

  ${Typography.Body} {
    color: ${({ theme, $color }) => $color ?? theme.palette.primary.labels};
  }
`;
